import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { Link } from "gatsby"
import { Row, Col } from "reactstrap"
import "../style/footer.css"

function Footer() {
  const data = useStaticQuery(graphql`
    query {
      ncmec: file(relativePath: { eq: "ncmec.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mk: file(relativePath: { eq: "mk.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <footer>
      <hr
        id="horizontal-rule"
        style={{ borderTop: "5px", borderStyle: "solid", color: "#454851" }}
      />
      <Row style={{ marginBottom: "1em" }}>
        <Col style={{ textAlign: "center", textDecoration: "none" }}>
          <Link className="footerLinks" to="/about">
            About ISP
          </Link>
        </Col>
        <Col style={{ textAlign: "center", textDecoration: "none" }}>
          <Link className="footerLinks" to="/legal">
            Legal Notice
          </Link>
        </Col>
        <Col style={{ textAlign: "center", textDecoration: "none" }}>
          <Link className="footerLinks" to="/privacy">
            Privacy Policy
          </Link>
        </Col>
      </Row>
      <Row>
        <Col className="tradeMark" xs="12" md={{ size: "6" }}>
          <p>All Trademarks and Copyrights Acknowledged</p>
        </Col>
        <Col className="copyright" xs="12" md={{ size: "6" }}>
          <p>Copyright 2016 International Software Products</p>
        </Col>
      </Row>
      <Row style={{ marginTop: "20px" }}>
        <Col className="footerImageCols my-auto" xs="6">
          <a
            href="http://www.missingkids.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Img
              className="footerImages ncmecImage"
              fluid={data.ncmec.childImageSharp.fluid}
              alt="The National Center for Kissing and Exploited Children Logo"
            />
          </a>
        </Col>
        <Col className="footerImageCols my-auto" xs="6">
          <a
            href="https://missingkids.ca/en/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Img
              className="footerImages mkImage"
              fluid={data.mk.childImageSharp.fluid}
              alt="Missing Kids Logo"
            />
          </a>
        </Col>
      </Row>
    </footer>
  )
}

export default Footer
